import { Environment } from '@playq/octopus-common';
import { Application, FacebookCredentials, AppleCredentials, GoogleCredentials } from '@playq/services-fingerprint';

import { resetModel } from '/helpers/model';

export function createBlankFingerprintConfiguration(_env: Environment): Application {
  const cfg = new Application();
  resetModel(cfg);
  cfg.integrations.facebook = new FacebookCredentials();
  cfg.integrations.apple = new AppleCredentials();
  cfg.integrations.google = new GoogleCredentials();
  cfg.integrations.apple.clientId = '';
  cfg.integrations.google.clientId = '';
  cfg.integrations.facebook.token = '';

  return cfg;
}
